import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { organizationIdentity } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useGetIdentityList = () => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useQuery(
    [orgId, 'identities'],
    async () => {
      const { data } = await axiosInstance.get(organizationIdentity(orgId).list);
      return data;
    },
    {
      onError: (err) => {
        const errorMessage = err.response?.data?.message || 'Failed to fetch identities';
        dispatch(showAlert({
          message: errorMessage,
          type: 'error',
        }));
      },
    },
  );
};
